import * as z from "zod";

export enum CancelReturnErrorCode {
  ReturnNotFound = "ReturnNotFound",
  Unauthorized = "Unauthorized",
  ReturnNotCancellable = "ReturnNotCancellable",
}

export const cancelReturn = {
  name: "cancelReturn" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
